import { useMemo, useRef } from "react";
import { useWidgetAddWidgetSizeState } from "../utils/useWidgetAddWidgetSizeState";
import { WidgetSizeT } from "../../localTypes/WidgetSizeT";

export function useWASizePreviewSize(props: {
  widgetSizes: WidgetSizeT[];
  maxSize: WidgetSizeT;
  defaultSize?: WidgetSizeT;
}) {
  const [size, setSize] = useWidgetAddWidgetSizeState({
    widgetSizes: props.widgetSizes,
    maxSize: props.maxSize,
    defaultSize: props.defaultSize,
  });
  const onViewableItemsChanged = useRef(({ viewableItems }: any) => {
    if (viewableItems[0]) {
      const index = viewableItems[0].index;
      const size = props.widgetSizes[index];
      setSize(size);
    }
  }).current;

  const scrollIndex = useMemo(() => {
    return props.widgetSizes.findIndex((s) => s.h === size.h && s.w === size.w);
  }, [props.widgetSizes, size.h, size.w]);

  return { size, onViewableItemsChanged, scrollIndex };
}
